import { apiGetExpiredFiles } from 'api';

export const callAction = async (fn) => {
  try {
    const res = await fn();
    if ([200, 201].includes(res?.data?.code)) {
      return { success: true, data: res.data };
    }
    return { success: false, error: res };
  } catch (error) {
    return { success: false, error };
  }
};

const useData = () => {
  const getExpiredFiles = async (key, id, params) => {
    return await callAction(() => apiGetExpiredFiles(key, id, params));
  };
  return {
    getExpiredFiles,
  };
};

export default useData;
